module.exports = __webpack_public_path__ + "static/media/ttsbot.2778aae7.svg";